import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Form,
  Modal,
  Row,
  Spin,
  Table,
  TreeSelect,
  Upload,
} from "antd";
import ColumnsAccountPlan from "./columns-table";
import { notificationErroInternal, notificationSucess } from "util/api-utils";
import { getUsers } from "services/user/user-service";
import { getCompanies } from "services/client/client-service";
const { SHOW_PARENT } = TreeSelect;

const Budget = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [data, setData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [value, setValue] = useState([]);
  const formRef = React.useRef(null);

  const treeData = companies.map((item) => {
    return {
      title: item.name,
      value: item.id,
      key: item.id,
    };
  });
  const handleUpload = () => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("files[]", file);
    });
    setUploading(true);
    setTimeout(() => {
      setFileList([]);
      setUploading(false);
      notificationSucess();
    }, 2000);
    // You can use any AJAX library you like
  };
  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
  };
  const tProps = {
    treeData,
    value,

    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: "Selecione uma empresa",
    style: {
      width: "100%",
    },
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    notificationSucess();

    setIsModalOpen(false);
  };
  const handleCancel = () => {
    formRef.current?.resetFields();

    setIsModalOpen(false);
  };
  useEffect(() => {
    setLoadingData(false);

    /* getUsers()
      .then((res) => {
        setLoadingData(false);
        setData(res);
      })
      .catch((err) => {
        setLoadingData(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });*/
    getCompanies()
      .then((res) => {
        setCompanies(res);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }, []);

  return (
    <div className="container-user">
      <Card
        className="card-user"
        title="Orçamentos"
        extra={
          <div>
            <Button type="primary" className="button-user" onClick={showModal}>
              Novo Orçamento
            </Button>
          </div>
        }
        bordered={false}
      >
        <Spin spinning={loadingData} size={"large"}>
          <Table
            columns={ColumnsAccountPlan}
            dataSource={data}
            pagination={{ pageSize: 10 }}
            locale={{
              emptyText: "Sem registro",
            }}
          />
        </Spin>
      </Card>
      <Modal
        style={{ textAlign: "center" }}
        title="Novo Orçamento"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form ref={formRef} style={{ maxWidth: 600 }}>
          <Form.Item
            name="companies"
            label="Empresas"
            rules={[
              {
                required: true,
                message: "É necessário informar uma empresa",
              },
            ]}
          >
            <TreeSelect {...tProps} />
          </Form.Item>
          <Form.Item
            name="files"
            label="Arquivo"
            rules={[
              { required: true, message: "É necessário informar o perfil" },
            ]}
          >
            <Upload {...props}>
              <Button type="primary" className="button-user">
                Anexar orçamento
              </Button>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default Budget;
